import script from "./BotsList.vue?vue&type=script&setup=true&lang=js"
export * from "./BotsList.vue?vue&type=script&setup=true&lang=js"

import "./BotsList.vue?vue&type=style&index=0&id=729da07b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-729da07b"]])

export default __exports__